import { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';

const navItems = [
  { id: 'body2', label: 'ABOUT', to: '/#body2' },
  { id: 'projects', label: 'PROJECTS', to: '/#projects' },
  { id: 'experiences', label: 'EXPERIENCES', to: '/#experiences' },
  { id: 'interests', label: 'INTERESTS', to: '/#interests' },
];

function Header() {
  const [isNavVisible, setNavVisibility] = useState(false);
  const [activeSection, setActiveSection] = useState('body2');

  const toggleNav = () => {
    setNavVisibility(!isNavVisible);
  };

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
        const headerOffset = 92;
        const offsetTop = Math.max(section.offsetTop - headerOffset, 0);
        window.scrollTo({
            top: offsetTop,
            behavior: 'smooth',
      });
      setNavVisibility(false);
    }
  };

  useEffect(() => {
    const updateActiveSection = () => {
      const headerOffset = 120;
      const currentSection = navItems.reduce((activeId, item) => {
        const section = document.getElementById(item.id);
        if (!section) {
          return activeId;
        }

        return section.offsetTop - headerOffset <= window.scrollY ? item.id : activeId;
      }, navItems[0].id);

      setActiveSection(currentSection);
    };

    updateActiveSection();
    window.addEventListener('scroll', updateActiveSection, { passive: true });
    window.addEventListener('resize', updateActiveSection);

    return () => {
      window.removeEventListener('scroll', updateActiveSection);
      window.removeEventListener('resize', updateActiveSection);
    };
  }, []);

  const getNavClassName = (sectionId, extraClass = '') =>
    `nav-pill ${activeSection === sectionId ? 'is-active' : ''} ${extraClass}`.trim();

  return (
    <header>
      {/* Font Awesome 아이콘 링크 */}
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css"
      />
      <div className="inner">
        <h1 className="logo">
          <NavLink to="/" className="logo-color">
            Branden Min
          </NavLink>
        </h1>

        <div className="mobile-menu-container">
          <button
            className={`toggle-button ${isNavVisible ? 'open' : ''}`}
            onClick={toggleNav}
            type="button"
            aria-label={isNavVisible ? 'Close navigation menu' : 'Open navigation menu'}
            aria-expanded={isNavVisible}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
          <div className={`mobile-menu ${isNavVisible ? 'open' : ''}`}>
            <ul className={`gnb ${isNavVisible ? 'open' : ''}`}>
              {navItems.map((item) => (
                <li key={item.id}>
                  <NavLink className={getNavClassName(item.id)} onClick={() => scrollToSection(item.id)} to={item.to}>
                    {item.label}
                  </NavLink>
                </li>
              ))}
              <li><a className="nav-pill cv-link" href="/BrandenMin.pdf" target="_blank" rel="noopener noreferrer">CV</a></li>
            </ul>
          </div>
        </div>

        <div className='pc-menu'>
          <ul className='web'>
            {navItems.map((item) => (
              <li key={item.id}>
                <NavLink className={getNavClassName(item.id)} onClick={() => scrollToSection(item.id)} to={item.to}>
                  {item.label}
                </NavLink>
              </li>
            ))}
            <li><a className="nav-pill cv-link" href="/BrandenMin.pdf" target="_blank" rel="noopener noreferrer">CV</a></li>
          </ul>
        </div>
        
        <div className="snsContact">
          <a href="https://www.linkedin.com/in/brandenmin/" target="_blank" rel="noopener noreferrer">
            <i className="fa-brands fa-linkedin"></i>
          </a>
          <a href="https://github.com/Gemnnn" target="_blank" rel="noopener noreferrer">
            <i className="fa-brands fa-github"></i>
          </a>
          <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer">
            <i className="fa-brands fa-facebook"></i>
          </a>
        </div>
      </div>
    </header>
  );
}

export default Header;
